// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boxborder{
  border-radius: 12px;
  border: 1px solid var(--Basic-LineCard, #E9E9E9);
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 212px;
  height: 80%;
  font-family: Open Sans variable, Helvetica;
  padding: 12px;

}

.vertical-tab-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 55.655px;
}

.abcd-buttons {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  width: 100%;
  align-items: center;
  gap: 10.601px;
  align-self: stretch;
}

.abcd-button {
  display: flex;
  padding: 3.534px 7.067px;
  justify-content: center;
  align-items: center;
  gap: 3.534px;
  flex: 1 0;
  border-radius: 21.202px;
  border: 0.883px solid var(--14bis-Light, #0071BA);
  background-color: var(--Blue-200, #DEF);
  color: #0071BA;
  font-size: 10px;
}

.abcd-button.selected {
  background-color: var(--14bis-Light, #0071BA);
  color: white;
}

.refresh-quadrant-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 50%;
  border: 0.883px solid var(--14bis-Light, #0071BA);
  background-color: var(--Blue-200, #DEF);
  color: #0071BA;
  cursor: pointer;
  flex-shrink: 0;
}

.refresh-quadrant-button:hover:not(:disabled) {
  background-color: var(--14bis-Light, #0071BA);
  color: white;
}

.refresh-quadrant-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.tabs-vertical {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 6px;
  align-items: center;
  align-self: stretch;
}

.tab-button {
  width: 100%;
  padding: 6px;
  border-radius: 6px 0 0 6px;
  border: 0.883px solid var(--Grey-400, #9FA6AD);
  background: var(--Basic-BGdisable, #F0F0F0);
  color: var(--Grey-400, #9FA6AD);
  cursor: pointer;
  font-size: 10px;
  font-family: Open Sans variable, Helvetica;

}

.tab-button.selected {
  border: 0.883px solid var(--14bis-Medium, #16478E);
  color: var(--14bis-Medium, #16478E);
  background: var(--Blue-200, #DEF);
}

.vertical-tab-and-image {
  display: flex;
  align-items: center;
  gap: 12px;
}

.tab-image-container img {
  justify-content: space-between;
  align-items: center;
  width: 146px;
  border-radius: 6px;
  border: 0.883px solid var(--Basic-LineCard, #E9E9E9);
}

.arrow-button {
  background: none;
  border: none;
  cursor: pointer;
  margin: 4px 0;
}
.weight-box-container{
  display: flex;
  flex-direction: column;
  gap: "6px";
}
.weight-box {
  display: flex;
  padding: 6px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  border: 0.883px solid var(--14bis-Light, #0071BA);
  background: var(--Blue-200, #DEF);
  color: var(--14bis-Dark, #182857);
  font-size: 12px;

}

`, "",{"version":3,"sources":["webpack://./src/containers/FinalPackingPage/FinalPackingNavTool.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,aAAa;;AAEf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,SAAW;EACX,uBAAuB;EACvB,iDAAiD;EACjD,uCAAuC;EACvC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,iDAAiD;EACjD,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,8CAA8C;EAC9C,2CAA2C;EAC3C,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,0CAA0C;;AAE5C;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,iDAAiD;EACjD,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;;AAEjB","sourcesContent":[".boxborder{\n  border-radius: 12px;\n  border: 1px solid var(--Basic-LineCard, #E9E9E9);\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 212px;\n  height: 80%;\n  font-family: Open Sans variable, Helvetica;\n  padding: 12px;\n\n}\n\n.vertical-tab-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 55.655px;\n}\n\n.abcd-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  width: 100%;\n  align-items: center;\n  gap: 10.601px;\n  align-self: stretch;\n}\n\n.abcd-button {\n  display: flex;\n  padding: 3.534px 7.067px;\n  justify-content: center;\n  align-items: center;\n  gap: 3.534px;\n  flex: 1 0 0;\n  border-radius: 21.202px;\n  border: 0.883px solid var(--14bis-Light, #0071BA);\n  background-color: var(--Blue-200, #DEF);\n  color: #0071BA;\n  font-size: 10px;\n}\n\n.abcd-button.selected {\n  background-color: var(--14bis-Light, #0071BA);\n  color: white;\n}\n\n.refresh-quadrant-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border-radius: 50%;\n  border: 0.883px solid var(--14bis-Light, #0071BA);\n  background-color: var(--Blue-200, #DEF);\n  color: #0071BA;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.refresh-quadrant-button:hover:not(:disabled) {\n  background-color: var(--14bis-Light, #0071BA);\n  color: white;\n}\n\n.refresh-quadrant-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.tabs-vertical {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 6px;\n  align-items: center;\n  align-self: stretch;\n}\n\n.tab-button {\n  width: 100%;\n  padding: 6px;\n  border-radius: 6px 0 0 6px;\n  border: 0.883px solid var(--Grey-400, #9FA6AD);\n  background: var(--Basic-BGdisable, #F0F0F0);\n  color: var(--Grey-400, #9FA6AD);\n  cursor: pointer;\n  font-size: 10px;\n  font-family: Open Sans variable, Helvetica;\n\n}\n\n.tab-button.selected {\n  border: 0.883px solid var(--14bis-Medium, #16478E);\n  color: var(--14bis-Medium, #16478E);\n  background: var(--Blue-200, #DEF);\n}\n\n.vertical-tab-and-image {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.tab-image-container img {\n  justify-content: space-between;\n  align-items: center;\n  width: 146px;\n  border-radius: 6px;\n  border: 0.883px solid var(--Basic-LineCard, #E9E9E9);\n}\n\n.arrow-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin: 4px 0;\n}\n.weight-box-container{\n  display: flex;\n  flex-direction: column;\n  gap: \"6px\";\n}\n.weight-box {\n  display: flex;\n  padding: 6px;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n  box-sizing: border-box;\n  border: 0.883px solid var(--14bis-Light, #0071BA);\n  background: var(--Blue-200, #DEF);\n  color: var(--14bis-Dark, #182857);\n  font-size: 12px;\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
